import Overview from "@wwdev/contentable/js/Overview";
new Overview;